exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n  Project Colors\n */\n/*\n  SCSS for app.component.ts\n */\n.container-fluid {\n  min-height: 100%;\n  margin-bottom: -100px;\n  background-color: #111111; }\n  .container-fluid .inner-wrapper {\n    overflow: hidden;\n    padding-bottom: 100px; }\n  .container-fluid .page-margin {\n    min-height: 100%;\n    margin-top: 60px; }\n\n:host {\n  display: block;\n  height: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = 382
// module chunks = 1